import { TIPO_FICHERO, TipoFicheroType } from "api/Types/TipoFichero"
import { find, findIndex } from "lodash"
import getFileExtension from "./getFileExtension"

export const FILE_TYPES = {
  desconocido: {
    value: TIPO_FICHERO.DESCONOCIDO,
    extensions: [],
  },
  imagen: {
    // TODO: Magic number
    value: TIPO_FICHERO.IMAGEN,
    extensions: ["png", "jpg", "gif", "tiff", "psd", "bmp", "svg"],
  },
  pdf: {
    value: TIPO_FICHERO.PDF,
    extensions: ["pdf"],
  },
  texto: {
    value: TIPO_FICHERO.TEXTO,
    extensions: ["txt", "rtf", "edi"],
  },
  excel: {
    value: TIPO_FICHERO.EXCEL,
    extensions: ["xls", "xlsx", "xlsm", "ods"],
  },
  doc: {
    value: TIPO_FICHERO.DOC,
    extensions: ["doc", "docx", "docm", "odt"],
  },
  csv: {
    value: TIPO_FICHERO.CSV,
    extensions: ["csv"],
  },
}

const getFileTypeToTheBE = (fileName = ""): TipoFicheroType => {
  const fileExtension = getFileExtension(fileName)

  const typeResult = find(FILE_TYPES, (type) => {
    const res = findIndex(
      type.extensions,
      (extencion) => extencion === fileExtension
    )

    return res !== -1
  })

  if (typeResult?.value || typeResult?.value === 0) {
    return typeResult.value
  }

  return FILE_TYPES.desconocido.value
}

export default getFileTypeToTheBE
